module.exports = __webpack_public_path__ + "/img/CQFP-Labeled-xVYk1P.svg";